import { render } from "./IncidentBanner.vue?vue&type=template&id=3fa2bf76&scoped=true"
import script from "./IncidentBanner.vue?vue&type=script&lang=js"
export * from "./IncidentBanner.vue?vue&type=script&lang=js"

import "./IncidentBanner.vue?vue&type=style&index=0&id=3fa2bf76&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa2bf76"]])

export default __exports__